import { Component, OnDestroy, OnInit } from "@angular/core";

import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-btn-cell-renderer",
  templateUrl: "./btn-cell-renderer.component.html",
  styleUrls: ["./btn-cell-renderer.component.scss"],
})
export class BtnCellRendererComponent
  implements OnDestroy, ICellRendererAngularComp {
  params: any;
  isShowIcon: boolean = false;
  private destroy$ = new Subject<void>();
  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if(this.params.data.shipped == this.params.data.received || this.params.data.isMarkAsResolved)
       this.isShowIcon = true;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  btnClickedHandler() {
    this.params.onClick(this.params.data);
  }

  retryBtnClickedHandler() {
    this.params.onRetry(this.params.data);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
